import { render, staticRenderFns } from "./customer-info-installation-note-card.vue?vue&type=template&id=47c81208"
import script from "./customer-info-installation-note-card.vue?vue&type=script&lang=js"
export * from "./customer-info-installation-note-card.vue?vue&type=script&lang=js"
import style0 from "./customer-info-installation-note-card.vue?vue&type=style&index=0&id=47c81208&prod&scpped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports